import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '影视分类', path: '/category' },
  { label: '资讯文章', path: '/article/latest' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${scrolled ? 'text-primary-600' : 'text-white'}`}>
              91影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.path
                    ? scrolled ? 'text-primary-600' : 'text-primary-400'
                    : scrolled ? 'text-foreground-700' : 'text-white/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/#download"
              className="whitespace-nowrap bg-primary-500 text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              立即下载
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-800' : 'text-white'}`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`whitespace-nowrap text-sm font-medium py-2 ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/#download"
              className="whitespace-nowrap bg-primary-500 text-white px-5 py-2.5 rounded-full text-sm font-medium text-center hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              立即下载
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}